module.exports = "<div class=\"reissue-table\">\n\t<div class=\"reissue-cell\">\n\t\t<div class=\"reissue-error\" *ngIf=\"error\">\n\t\t\t<span class=\"icon icon-warning\"></span>\n\t\t\t<p>{{error}}</p>\n\t\t</div>\n\n\t\t<div class=\"reissue-success\" *ngIf=\"!error\">\n\t\t\t<span class=\"icon icon-refresh spin\"></span>\n\t\t\t<h1>Loading your Marketplace...</h1>\n\t\t</div>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/matthewspringbett/sites/worryandpeace/valhalla/src/app/reissue/reissue.component.html
// module id = ../../../../../src/app/reissue/reissue.component.html
// module chunks = 1